import React from 'react';

var EventFeeContainer = React.createClass({
  propTypes: {
    fees: React.PropTypes.array,
    onIncreaseFeeQty: React.PropTypes.func.isRequired,
    onDecreaseFeeQty: React.PropTypes.func.isRequired
  },
  increaseFeeQty: function(name, price, limit, total_limit, qty, id, label, is_front_end) {

    const data = { fee_id: id, fee_name: name, front_end:is_front_end };
    
    $.ajax({
      url: '/events/get_limit_total',
      type: 'POST',
      data: data,
      dataType: 'json'
    })
    .done(( data, textStatus, jqXHR ) => {

      //skip validation in backend
      if(is_front_end === true) {
        //reutrn current DB count
        var currentCount = data.currentCount;

        if (total_limit > 0 && (qty+1+currentCount) > total_limit) {
          return swal({
            title: 'Error',
            text: 'Sorry, "' + label + '" has reached the maximum capacity.',
            type: 'error'
          });
        }

        if (++qty > limit) {
          return swal({
            title: 'Error',
            text: limit == 1 ? 'You may only register for this item once' : 'You may only register for this item a maximum of '+limit+ ' times.',
            type: 'error'
          });
        }
      }

      

      this.props.onIncreaseFeeQty(name, price);

    })
    .fail(( jqXHR, textStatus ) => {
      var response = $.parseJSON(jqXHR.responseText);
      return swal({
        title: 'Error',
        text: response.error.message,
        type: 'error'
      })
    });

  
  },


  render: function() {
    const { is_front_end, admin, onIncreaseFeeQty, onDecreaseFeeQty, onChange, fees } = this.props;

    // console.log(this.props);

    return(
      <div className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicon glyphicon-list-alt"></span> Please select items </div>
        </div>
        <div className="panel-body">
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="col-sm-7">Register Me For:</th>
                <th className="col-sm-2">Price</th>
                <th className="col-sm-3">Qty</th>
              </tr>
            </thead>
            <tbody>
              { !fees ? undefined : fees.map( (f) =>
                <tr key={f.id}>
                  <td>{f.label}</td>
                  <td>${f.price}</td>
                  <td>

                    {f.is_sold_out && f.is_sold_out == true && is_front_end == true ? (
                      <div className="sold-out-contaner">
                        <p className="text-danger text-center font-weight-bold">SOLD OUT!</p>
                      </div>
                    ) : (
                      <div className="input-group">
                        <span className="input-group-btn">
                          <button className="btn btn-default" type="button" onClick={onDecreaseFeeQty.bind(null, f.name, f.price)}>-</button>
                        </span>
                        <input type="number" className="form-control text-center" name={f.name} value={f.qty} readOnly />
                        <span className="input-group-btn">
                          <button className="btn btn-default" type="button" onClick={this.increaseFeeQty.bind(null, f.name, f.price, f.limit, f.total_limit, f.qty, f.id , f.label, is_front_end)}>+</button>
                        </span>
                      </div>
                    )}

                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
});

export default EventFeeContainer;


// WEBPACK FOOTER //
// ./src/components/event_fee_container.js